import clsx from 'clsx'
import parse from 'html-react-parser'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { HouseContext } from '../../../../../lib/graphql'

const ProposalSpecialConditions = ({
  specialConditions,
  containerStyle = {},
  containerClassName,
}: {
  specialConditions?: HouseContext['specialConditions']
  containerStyle?: React.CSSProperties
  containerClassName?: string
}) => {
  if (specialConditions?.url) {
    // embed the pdf url in an iframe
    return (
      <div
        className={clsx(s.container, containerClassName)}
        style={{ marginTop: 20, ...containerStyle }}
      >
        <embed
          src={specialConditions.url}
          type='application/pdf'
          width='100%'
          height='800px'
        />
      </div>
    )
  }

  if (specialConditions?.text) {
    return (
      <div
        className={clsx(s.container, containerClassName)}
        style={{ marginTop: 20, ...containerStyle }}
      >
        <div>{parse(`${specialConditions.text}`)}</div>
      </div>
    )
  }

  return (
    <div
      className={clsx(s.container, containerClassName)}
      style={{ marginTop: 20, ...containerStyle }}
    >
      <FormattedMessage
        id='ui.ProposalSpecialConditions.noSpecialConditions'
        defaultMessage='Pas de conditions spéciales'
      />
    </div>
  )
}

export default ProposalSpecialConditions
